
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_6xiez_1ns0c_5"
};
  